@if (config.buttons?.contactUs?.modal; as contactConfig) {
  <modal
    [condition]="isOpen"
    [config]="{
      type: 'flyout',
      header: contactConfig.header,
    }"
  >
    <ng-container body>
      <h4 class="NavContactUs__title">{{ contactConfig.title }}</h4>
      @for (section of ['phone', 'email']; track section) {
        @if (contactConfig[section]; as sect) {
          <section class="NavContactUs__section">
            <div class="NavContactUs__header">
              <icon
                class="NavContactUs__icon"
                [name]="sect.icon"
                [config]="{ set: 'product' }"
              >
              </icon>
              <h6 class="NavContactUs__subtitle">{{ sect.label }}</h6>
            </div>
            @for (attribute of sect.attributes; track attribute) {
              <model-attribute
                class="NavContactUs__attribute"
                [config]="attribute"
              >
              </model-attribute>
            }
          </section>
        }
      }
    </ng-container>
    <ng-container footer>
      <div class="u-flex u-justifyEnd u-maxX">
        <zip-button
          [config]="{
            level: 'high',
            content: 'Close',
          }"
          (zipButtonClicked)="close()"
        >
        </zip-button>
      </div>
    </ng-container>
  </modal>
}
